import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { connect } from "react-redux";

const PrivateRoute = ({ auth, ...rest }: any) => {
  if (auth == null) {
    const _url = new URL(window.location.href);
    if ((_url.pathname || "/") !== "/") {
      const return_url = _url.pathname + _url.search;
      window.localStorage.setItem('return_url', return_url);
    }

    return <Redirect to={{ pathname: '/' }} />
  }

  return <Route {...rest} />;
}

const mapStateToProps = (state: any) => {
  return {
    auth: state.auth.userData
  }
};

const mapDispatchToProps = () => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PrivateRoute);
